import { AdjustmentType } from "@redotech/cockroachdb-codegen/congodb/adjustment-type";
import {
  ProductZodSchema,
  ReturnZodSchema_,
} from "@redotech/redo-return-core-common/return";
import { ReturnSummaryTotalsSchema } from "@redotech/redo-return-core-common/returns/return-totals/types";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const AdjustmentOverrideSchema = z.object({
  flatInPresentmentCurrency: z.number(),
  proportion: z.number(),
  type: createEnum(AdjustmentType),
});

export const getReturnTotals = {
  name: "getReturnTotals" as const,
  input: z.object({
    returnId: z.string(),
    overrides: z
      .object({
        fields: ReturnZodSchema_.partial().optional(),
        adjustmentOverrides: z.array(AdjustmentOverrideSchema).optional(),
        productOverrides: z
          .array(
            z.object({
              productObjectId: z.string(),
              adjustmentOverrides: z.array(AdjustmentOverrideSchema).optional(),
              fields: ProductZodSchema.partial(),
            }),
          )
          .optional(),
      })
      .nullish(),
  }),
  output: z.object({
    returnSummaryTotals: ReturnSummaryTotalsSchema.optional(),
  }),
};
